import React from "react";
import { Box, Typography } from "@bca/ui-library";

import ExclamationTriangleSVG from "../Icons/ExclamationTriangleSVG";

const SalesError = () => {
  return (
    <Box
      width="314px"
      height="400px"
      display="flex"
      flexDirection="column"
      margin="0 auto"
      alignItems="center"
      justifyContent="center"
    >
      <ExclamationTriangleSVG
        height="74px"
        fill="#64798c"
      ></ExclamationTriangleSVG>
      <Typography
        variant="h4"
        marginTop="16px"
        marginBottom="12px"
        textAlign="center"
        color="#060916"
      >
        Sorry, something went wrong
      </Typography>
      <Typography
        variant="h6"
        marginTop="16px"
        textAlign="center"
        margin="0"
        color="#64798c"
        padding="0 20px"
        css="font-weight: 400"
      >
        We were unable to load the sales, please{" "}
        <a href="" style={{ textDecoration: "none", color: "#2196f3" }}>
          try again
        </a>
      </Typography>
    </Box>
  );
};

export default SalesError;
